import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnInit,
  PLATFORM_ID,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ApplicationConfig } from '../../config/config';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { ErrorMessagesReducerStoreService } from '../../store/services/error-message.reducer.service';

declare let delta: any;

@Component({
  selector: 'ngc-business-alert',
  templateUrl: './business-alert.component.html'
})
export class BusinessAlertComponent implements OnInit, OnChanges {
  // businessErrorMessage = '';
  @ViewChild('bussinessAlert') bussinessAlert: ElementRef;
  businessErrorMessage: Subscription;
  errorMessagesServiceSubscribe: Subscription;
  showBussinessAlert = false;
  businessAlertDetails: any;
  businessMessage: any;
  datasss: any;
  dashBoardData: any;
  accountSummaryServiceSubscribe: Subscription;
  private unsubscribe: Subject<void> = new Subject();
  @Input() reRender = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private accountSummaryService: AccountSummaryService,
    private appConfig: ApplicationConfig,
    private errorService: ErrorMessagesReducerStoreService,
    private datalayer: DataLayer,
    private userSession: UserSessionService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId)) {
      this.listenToEvents();
    }
  }

  listenToEvents() {
    // TODO: needs to refactor code - B-664953
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('service-worker-token', () =>
        this.getAccountDetails()
      );
    }
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.userSession.getServiceWorkerCheck()) {
        this.getAccountDetails();
      }
    }
  }

  getAccountDetails() {
    this.accountSummaryServiceSubscribe = this.accountSummaryService
      .getAccountSummaryDetails()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.dashBoardData = res;
        const corporateError = this.appConfig.get('APP_CONCUR_CORPORATE_ERROR')
          ? this.appConfig.get('APP_CONCUR_CORPORATE_ERROR')
          : '';
        if (this.dashBoardData) {
          const triplinkErrorCd = this.dashBoardData.triplinkErrorCd
            ? this.dashBoardData.triplinkErrorCd
            : '';
          if (triplinkErrorCd === corporateError) {
            this.getAEMErrorBussinessMessage();
          }
        }
      });
  }

  getAEMErrorBussinessMessage() {
    this.errorMessagesServiceSubscribe = this.errorService.errorMessages
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if (data) {
          if (data.errorMessages) {
            this.businessMessage = data.errorMessages.get('ACC_UNAVAILABLE')
              ? data.errorMessages.get('ACC_UNAVAILABLE')
                  .errorMessageDescription
              : '';
            if (this.businessMessage) {
              this.showBussinessAlert = true;
              setTimeout(() => {
                this.showAlertMessage();
              }, 1000);
            }
          }
        }
      });
  }

  closeBussinessAlertBanner() {
    this.showBussinessAlert = false;
  }

  showAlertMessage() {
    if (
      document.getElementById('homepage:banner') &&
      this.bussinessAlert?.nativeElement
    ) {
      const banner = document.getElementById('homepage:banner').innerHTML;
      document.getElementById('homepage:banner').innerHTML =
        this.bussinessAlert.nativeElement.innerHTML + banner;
    }
  }
}
